import { ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import * as graphql from 'generated/graphql';
import Button, { ButtonSize } from 'packages/kakapo-ui-kit/components/editors/Button';

import EditModal from './EditModal';

export default function CreateModal(props: {
	item: graphql.EvaluationSectionItem;
	onCancel: () => void;
	onCreate: (item: graphql.EvaluationSectionItem) => void;
}): ReactElement {
	const { t } = useTranslation();

	const [item, setItem] = useState<graphql.EvaluationSectionItem | undefined>(undefined);

	return (
		<>
			<EditModal item={item || props.item} onUpdate={(_, item) => setItem(item)} />
			<Flex alignItems="center">
				<Button
					size={ButtonSize.Medium}
					enabled={!!item}
					onClick={() => item && props.onCreate(item)}
				>
					{t('common.add')}
				</Button>
				<Box ml={3}>
					<Button size={ButtonSize.Medium} onClick={() => props.onCancel()}>
						{t('common.cancel')}
					</Button>
				</Box>
			</Flex>
		</>
	);
}
